const riot = require('riot');

riot.tag2('module-sidebar', '<div class="absolute t0 b0 l0"> <div class="h-full f flex-around writing-lr px16 py64 fs12 s-py128 s-px4"><a class="block menu py32 px8 s-py16 {getCurrent() === link.id ? &quot;bold fs16 text-white&quot; :&quot;text-softgray&quot;}" each="{link in links}" href="{link.link}" onclick="{gotoLink}" target="{&quot;_blank&quot; : (link.label===&quot;Y.dusk&quot; || link.label===&quot;CONTACT&quot; )}">{link.label}</a></div> </div>', 'module-sidebar .menu,[data-is="module-sidebar"] .menu{color:rgba(255,255,255,0.5)} module-sidebar .menu:hover,[data-is="module-sidebar"] .menu:hover{color:#fff !important}', '', function(opts) {
    this.getCurrent = () => {
      var path = location.pathname;
      path = path.replace('/', '');
      if (!path) return 'top';
      return path;
    };

    this.links = [
      {id: 'top', label: 'HOME', link: '/'},
      {id: 'bio', label: 'BIO', link: '/bio'},
      {id: 'works', label: 'WORKS', link: '/works'},

      {id: 'ydusk', label: 'Y.dusk', link: 'https://y-dusk.slcl.shop'},
      {id: 'contact', label: 'CONTACT', link: 'https://docs.google.com/forms/d/e/1FAIpQLScxOEp5llGAA8__g3cdPZmDUiodWpE8EP_GhF6PzgRTO4OLGQ/viewform'},
    ];

    this.gotoLink = (e) => {
      if (e.item.link.label === 'Y.dusk' || e.item.link.label === 'CONTACT') return ;
      e.preventDefault();
      e.stopPropagation();
      spat.router.push(e.currentTarget.href);
    };
});